// Fila de denúncias (só moderador/admin): prova guardada e ações.
import { api, errorMessage, type ModReport } from "../api";
import { lang, t, type MsgKey } from "../i18n";
import type { View } from "../router";
import { esc, screen } from "../ui";

export const moderationView: View = (root, { query }) => {
  const tab = query.get("aba") === "fechadas" ? "closed" : "open";
  root.innerHTML = screen(t("mod.title"), "/menu", `
    <div class="bw-tabs">
      <a class="bw-btn ${tab === "open" ? "bw-btn--blue" : ""}" href="#/moderacao">${t("mod.open")}</a>
      <a class="bw-btn ${tab === "closed" ? "bw-btn--blue" : ""}" href="#/moderacao?aba=fechadas">${t("mod.closed")}</a>
    </div>
    <div data-alert hidden></div>
    <div data-list><div class="bw-textbox">${t("common.loading")}</div></div>`);
  const list = root.querySelector<HTMLElement>("[data-list]")!;
  const show = (msg: string, kind = "error") => {
    const a = root.querySelector<HTMLElement>("[data-alert]")!;
    a.className = `bw-alert bw-alert--${kind}`;
    a.textContent = msg;
    a.hidden = false;
  };
  const when = (d: string | null) => (d ? new Date(d).toLocaleString(lang()) : "");

  const card = (r: ModReport) => `
    <article class="bw-panel bw-stack mod-report">
      <div class="mod-head">
        <b>${esc(r.target_nickname)}</b> <span class="bw-dim small">@${esc(r.target_username)}</span>
        <span class="bw-type">${t(`report.reason.${r.reason}` as MsgKey)}</span>
        <span class="bw-dim small">${t("mod.by", { name: esc(r.reporter), when: when(r.created_at) })}</span>
      </div>
      <p class="small" style="margin:0">${t("mod.counts", { open: r.target_open, people: r.target_reporters })}
        ${r.chat_muted_until && new Date(r.chat_muted_until) > new Date() ? ` · <b>${t("mod.mutedUntil", { when: when(r.chat_muted_until) })}</b>` : ""}
        ${r.banned_until && new Date(r.banned_until) > new Date() ? ` · <b>${t("mod.bannedUntil", { when: when(r.banned_until) })}</b>` : ""}</p>
      ${r.details ? `<blockquote class="mod-details">${esc(r.details)}</blockquote>` : ""}
      ${r.evidence.nickname !== r.target_nickname ? `<p class="small" style="margin:0">${t("mod.nickAtTime", { name: esc(r.evidence.nickname) })}</p>` : ""}
      ${r.evidence.chat.length || r.evidence.roomChat.length ? `<details><summary>${t("mod.evidence", { n: r.evidence.chat.length + r.evidence.roomChat.length })}</summary>
        <ul class="msgs mod-msgs">
          ${r.evidence.chat.map((m) => `<li class="msg"><span class="bw-dim small">${esc(m.channel)} · ${when(m.at)}</span> ${esc(m.text)}</li>`).join("")}
          ${r.evidence.roomChat.map((m) => `<li class="msg"><span class="bw-dim small">${t("mod.room")} · ${esc(m.nickname)}</span> ${esc(m.text)}</li>`).join("")}
        </ul></details>` : `<p class="bw-dim small" style="margin:0">${t("mod.noEvidence")}</p>`}
      ${tab === "open" ? `<div class="mod-actions">
        <button class="bw-btn" data-act="dismiss" data-id="${r.id}">${t("mod.dismiss")}</button>
        <button class="bw-btn bw-btn--blue" data-act="mute" data-hours="24" data-id="${r.id}">${t("mod.mute24")}</button>
        <button class="bw-btn bw-btn--blue" data-act="rename" data-id="${r.id}">${t("mod.rename")}</button>
        <button class="bw-btn bw-btn--red" data-act="ban" data-hours="72" data-id="${r.id}">${t("mod.ban3d")}</button>
        <button class="bw-btn bw-btn--red" data-act="ban" data-hours="8760" data-id="${r.id}">${t("mod.ban1y")}</button>
      </div>` : `<p class="small" style="margin:0">${t("mod.result", { action: esc(r.action ?? ""), when: when(r.resolved_at) })}</p>`}
    </article>`;

  async function load() {
    try {
      const { reports } = await api.modReports(tab);
      list.innerHTML = reports.length ? reports.map(card).join("") : `<div class="bw-textbox">${t("mod.empty")}</div>`;
    } catch (e) {
      list.innerHTML = `<div class="bw-alert bw-alert--error">${esc(errorMessage(e))}</div>`;
    }
  }

  list.addEventListener("click", async (e) => {
    const b = (e.target as HTMLElement).closest<HTMLButtonElement>("[data-act]");
    if (!b) return;
    if (b.dataset.act === "ban" && !b.dataset.confirm) {
      b.dataset.confirm = "1";
      b.textContent = t("mod.confirm");
      return;
    }
    b.setAttribute("aria-busy", "true");
    try {
      await api.modResolve(Number(b.dataset.id), b.dataset.act as "dismiss" | "mute" | "rename" | "ban", b.dataset.hours ? Number(b.dataset.hours) : undefined);
      show(t("mod.done"), "ok");
      await load();
    } catch (err) {
      show(errorMessage(err));
    }
  });
  void load();
};
